module.exports = __webpack_public_path__ + "static/media/BuenosAiresWeb-LightItalic.b61c7946.woff2";